import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { Col, Label } from 'reactstrap';

import InputDate from '../InputDate/InputDate';

const updateDate = (value) =>
  !!value ? moment(value).utc().format('YYYY-MM-DD') : '';
const isSameDate = (value, startDate) => moment(value).isSame(startDate);

const InputDateRangeField = ({ fields, name, _handleChange, value }) => {
  const [dateRange, setDateRange] = useState(value || { $gte: '', $lt: '' });
  
  const updateDateRange = (currentDate, newDate, key) => {
    if (!isSameDate(currentDate[key], newDate[key])) {
      setDateRange((currentState) => ({
        ...currentState,
        [key]: updateDate(newDate[key]),
      }));
    }
  };

  useEffect(() => {
    if (!value) return;

    updateDateRange(dateRange, value, '$gte');
    updateDateRange(dateRange, value, '$lt');
  }, [value]);

  const [startField, endField] = fields;

  const changeInput = (value, stateKey) => {
    let date = !!value ? new Date(value) : '';

    if (!!date && stateKey === '$lt') {
        date = moment(date).utc()
            .hour(23)
            .minutes(59)
            .seconds(59)
            .millisecond(999);
    };

    const newDateRange = {
      ...dateRange,
      [stateKey]: date,
    };

    setDateRange(newDateRange);

    _handleChange(newDateRange, name, stateKey, value);
  };

  return (
    <React.Fragment>
      <Col
        sm={startField.sizeSm || 0}
        md={startField.sizeMd || 0}
        lg={startField.sizeLg || 0}
      >
        <Label>{startField.label}</Label>
        <InputDate
          type="date"
          value={updateDate(dateRange['$gte'])}
          onChange={(value) => changeInput(value, '$gte')}
          name={startField.name}
          id={startField.name}
          placeholder="00/00/0000"
        />
      </Col>
      <Col
        sm={endField.sizeSm || 0}
        md={endField.sizeMd || 0}
        lg={endField.sizeLg || 0}
      >
        <Label>{endField.label}</Label>
        <InputDate
          type="date"
          value={updateDate(dateRange['$lt'])}
          onChange={(value) => changeInput(value, '$lt')}
          name={endField.name}
          id={endField.name}
          placeholder="00/00/0000"
        />
      </Col>
    </React.Fragment>
  );
};

export default InputDateRangeField;
